import { render, staticRenderFns } from "./Hangs.vue?vue&type=template&id=161835dc&scoped=true&"
import script from "./Hangs.vue?vue&type=script&lang=js&"
export * from "./Hangs.vue?vue&type=script&lang=js&"
import style0 from "./Hangs.vue?vue&type=style&index=0&id=161835dc&prod&lang=scss&scoped=true&"
import style1 from "./Hangs.vue?vue&type=style&index=1&id=161835dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161835dc",
  null
  
)

export default component.exports